<section class="page-shell">
  <header class="page-header">
    <div>
      <p class="eyebrow">Technique</p>
      <h2>Suivi des caches</h2>
      <p class="page-description">
        Vue de supervision de l’alimentation des caches investisseur Atlas, ImmoFactory et Box Placement.
      </p>
    </div>

    <oui-button type="outlined" (click)="reload()">Actualiser</oui-button>
  </header>

  @if (loading() && !response()) {
    <dbw-state-card title="Chargement" appearance="loading">
      <p>Lecture des informations techniques en cours.</p>
    </dbw-state-card>
  } @else if (error() && !response()) {
    <dbw-state-card title="Erreur" appearance="error">
      <p>{{ error() }}</p>
    </dbw-state-card>
  } @else {
    @if (response(); as technicalResponse) {
      <oui-tab-group>
        <oui-tab label="Caches">
          <div class="tab-content">
            <dbw-summary-grid [items]="summaryItems()"></dbw-summary-grid>

            @if (error()) {
              <dbw-state-card title="Dernière erreur" appearance="error" [compact]="true">
                <p>{{ error() }}</p>
              </dbw-state-card>
            }

            <div class="cache-grid">
              @for (cache of technicalResponse.caches; track cache.key) {
                <section class="dbw-card dbw-card--xl cache-card">
                  <div class="cache-card__header">
                    <div>
                      <h4>{{ cache.label }}</h4>
                      <p>{{ cache.notes || cache.feedingMode }}</p>
                    </div>

                    <div class="cache-card__tags">
                      <oui-tag type="status" [status]="getCacheStatusTag(cache)">
                        {{ getCacheStatusLabel(cache) }}
                      </oui-tag>

                      @if (cache.isWarmupInProgress || cache.isWarmupCompleted || cache.warmupLoadedCount > 0) {
                        <oui-tag type="status" [status]="getWarmupTag(cache)">
                          Warmup: {{ cache.warmupLoadedCount }}
                        </oui-tag>
                      }
                    </div>
                  </div>

                  <oui-table class="data-table" [lineSizing]="'dense'">
                    <table mat-table [dataSource]="[cache]">
                      <ng-container matColumnDef="cache">
                        <th mat-header-cell *matHeaderCellDef>Cache</th>
                        <td mat-cell *matCellDef="let row">
                          <div class="metric-stack">
                            <strong>{{ row.label }}</strong>
                            <span>{{ row.key }}</span>
                          </div>
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="entries">
                        <th mat-header-cell *matHeaderCellDef>Entrées</th>
                        <td mat-cell *matCellDef="let row">
                          <div class="metric-stack">
                            <strong>{{ row.entryCount }}</strong>
                            <span>Dernière MAJ: {{ formatDate(row.lastValueUpdateUtc) }}</span>
                          </div>
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="feedingMode">
                        <th mat-header-cell *matHeaderCellDef>Alimentation</th>
                        <td mat-cell *matCellDef="let row">
                          <div class="metric-stack">
                            <strong>{{ row.feedingMode }}</strong>
                            <span>
                              @if (row.isWarmupCompleted) {
                                Warmup terminé
                              } @else if (row.isWarmupInProgress) {
                                Warmup démarré
                              } @else {
                                Sans warmup dédié
                              }
                            </span>
                          </div>
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="refresh">
                        <th mat-header-cell *matHeaderCellDef>Dernier chargement</th>
                        <td mat-cell *matCellDef="let row">
                          <div class="metric-stack">
                            <strong>{{ formatDate(row.lastRefreshCompletedUtc) }}</strong>
                            <span>Démarré: {{ formatDate(row.lastRefreshStartedUtc) }}</span>
                          </div>
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="expiration">
                        <th mat-header-cell *matHeaderCellDef>Expiration</th>
                        <td mat-cell *matCellDef="let row">
                          <div class="metric-stack">
                            <strong>{{ formatDate(row.expiresAtUtc) }}</strong>
                            <span>
                              @if (row.isRefreshInProgress) {
                                Rechargement en cours
                              } @else {
                                Stable
                              }
                            </span>
                          </div>
                        </td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                    </table>
                  </oui-table>
                </section>
              }
            </div>
          </div>
        </oui-tab>
      </oui-tab-group>
    }
  }
</section>
